import { connect } from "react-redux";
import OscApp from "../components/OscApp";
import {
  setStage,
  setLogout,
  logout,
  openMenu,
  callGoogleAnalytics,
  setFocus,
  populateCards,
  Stages,
  setIsCalProvider,
  selectCard,
  setLoader,
  setError,
  callGoogleAnalyticsEvent,
} from "../actions/actions";
import { goToUrl } from "../actions/services";
import exitTop from "../assets/images/exit-top.svg";

const mapDispatchToProps = (dispatch) => {
  return {
    onSetStage: (stage) => {
      return dispatch(setStage(stage));
    },
    onSetLoader: (displayLoader) => {
      return dispatch(setLoader(displayLoader));
    },
    selectCard: (last4Digits) => {
      return dispatch(selectCard(last4Digits));
    },
    setPopulateCards: (cards) => {
      dispatch(populateCards(cards));
    },
    setError: (status, text) => {
      return dispatch(setError(status, text));
    },

    onOpenMenu: (isMenuOpen) => {
      if (isMenuOpen) {
        dispatch(setFocus("sidebar"));
        dispatch(callGoogleAnalytics(window.settings.ga.pages.menu));
      } else {
        dispatch(setFocus("title"));
      }
      return dispatch(openMenu(isMenuOpen));
    },
    onOpenLogoutMessage: (url, stage, text) => {
      text = text || window.settings.provider.labels.logoutText;

      let okText = window.settings.provider.labels.logoutOkText;
      let cancelText = window.settings.provider.labels.logoutCancelText;
      dispatch(setLogout(url, stage, text, exitTop, okText, cancelText, false));
    },
    onCloseLogoutMessage: () => {
      dispatch(setLogout(null, null));
    },
    onLogout: (stage) => {
      if (stage === "LOGIN") {
        let url = "";
        if (window.hidenavbar == "false" || window.hidenavbar == false) {
          url = window.settings.provider.homeSiteUrl;
        } else {
          url = window.returnAppUrl;
        }

        if (url.toLowerCase().indexOf("cal") > -1)
          dispatch(callGoogleAnalytics(window.settings.ga.pages.calWebsite));
        else if (url.toLowerCase().indexOf("diners") > -1)
          dispatch(callGoogleAnalytics(window.settings.ga.pages.dinersWebsite));
        goToUrl(url);
      } else {
        dispatch(callGoogleAnalytics(window.settings.ga.pages.logout));
        if (window.hidenavbar == "false" || window.hidenavbar == false) {
          stage = stage || Stages.thankYou;
          dispatch(setLogout(null, null));
          dispatch(logout());
          dispatch(setStage(stage));
          dispatch(setIsCalProvider(window.isCalProvider));
        } else {
          goToUrl(window.returnAppUrl);
        }
      }
    },
    onSessionExpiredLogout: () => {
      dispatch(
        callGoogleAnalyticsEvent("online-secret-code", "time-out'", "login")
      );
      dispatch(callGoogleAnalytics(window.settings.ga.pages.logout));
      let stage = "LOGIN";
      dispatch(setLogout(null, null));
      dispatch(logout());
      dispatch(setStage(stage));
      dispatch(setIsCalProvider(window.isCalProvider));
    },
    onSessionExpiredExit: () => {
      dispatch(
        callGoogleAnalyticsEvent(
          "online-secret-code",
          "time-out'",
          "exit-cal-website'"
        )
      );
      let url = window.settings.provider.homeSiteUrl;
      if (window.hidenavbar == "false" || window.hidenavbar == false) {
        if (url.toLowerCase().indexOf("cal") > -1)
          dispatch(callGoogleAnalytics(window.settings.ga.pages.calWebsite));
        else if (url.toLowerCase().indexOf("diners") > -1)
          dispatch(callGoogleAnalytics(window.settings.ga.pages.dinersWebsite));
      } else {
        url = window.returnAppUrl;
      }
      goToUrl(url);
    },
    onFocus: (refName) => {
      dispatch(setFocus(refName));
    },
    onExit: (url, withLogout) => {
      if (url.toLowerCase().indexOf("cal") > -1)
        dispatch(callGoogleAnalytics(window.settings.ga.pages.calWebsite));
      else if (url.toLowerCase().indexOf("diners") > -1)
        dispatch(callGoogleAnalytics(window.settings.ga.pages.dinersWebsite));

      goToUrl(url);
      if (withLogout) {
        dispatch(setLogout(null, null));
        dispatch(logout());
      }
    },
    onIsCalProvider: () => {
      dispatch(setIsCalProvider(window.isCalProvider));
    },
    onGoBack: () => {
      window.history.go(-1);
    },
    gotToCardsPage: () => {
      dispatch(
        callGoogleAnalyticsEvent(
          "online-secret-code",
          "show-code-success",
          "view-another-card"
        )
      );

      dispatch(setStage(Stages["cards"]));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    stage: state.session.app.stage,
    isConnected: state.session.app.isConnected,
    source: state.session.app.source,
    focusOn: state.session.app.focusOn,
    logoutMessage: state.session.app.message
      ? state.session.app.message.logout
      : null,
    isMenuOpen: state.session.app.isMenuOpen,
    isLoading: state.session.app.isLoading,
    isCalProvider: state.session.app.isCalProvider,
    provider: window.provider,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OscApp);



// WEBPACK FOOTER //
// ./src/containers/OscApp.js